import React from 'react';
import './Logo.css';

const Logo = ({ src = '/logo-transparent.png', height, width }) => {
  return (
    <div className="logo">
      <div className="logo-icon">
        <img 
          src={src}
          alt="Rastromais Logo"
          className="logo-image"
          style={{ height: height, width: width }}
        />
      </div>
    </div>
  );
};

export default Logo;